<template>
    <div style="display: flex; flex-direction: column; padding: 0 12px; position: relative">
        <div style="margin-top: 100px; text-align: center;">
            <div style="font-weight: 900; font-size: 32px; line-height: 40px;">
                <span style="color: var(--color-main);">{{ $GlobalStore.loginInfo().nic_name }}</span>
                님, 환영합니다!
            </div>      
        </div>
        <div style="margin-top: 10px; font-weight: 500; line-height: 22px; color: #797979; text-align: center;">사커하우 AI가 회원님의 축구 성향을 분석해<br>딱 맞는 최적의 포지션을 찾아드립니다.</div>
        <div style="display: flex; gap: 16px; margin-top: 30px;">
            <div style="flex: 1;">
                <div @click="findPositionLite" class="position_card lite">
                    <div class="back_img">
                        <img style="width: 100%;" :src="require('@/assets/img/lite_back.png')" alt="">
                    </div>
                    <div class="position_card_content_wrapper">
                        <div style="color: var(--color-main);" class="badge">LITE</div>
                        <div class="position_card_content">
                            <div>
                                <img style="width: 95px;" :src="require('@/assets/img/position_lite_icon.png')" alt="">
                            </div>
                            <div class="position_card_content_title">내 축구 포지션을<br>정확히 알아보기</div>
                            <div class="position_card_content_desc">쉽게 할 수 있는 포지션 찾기 LITE</div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="flex: 1; position: relative">
                <div @click="findPositionPro" class="position_card pro">
                    <div class="back_img">
                        <img style="width: 100%;" :src="require('@/assets/img/pro_back.png')" alt="">
                    </div>
                    <div class="position_card_content_wrapper">
                        <div style="color: #213D51" class="badge">PRO</div>
                        <div class="position_card_content">
                            <div class="special_color">PRO</div>
                            <div class="position_card_content_title">200명의 축구 전문가들의<br>정밀한 분석</div>
                            <div class="position_card_content_desc">프로들의 포지션 찾기 PRO</div>
                        </div>
                    </div>
                </div>
                <div class="pro_desc">포지션 찾기 PRO는 유료입니다.</div>
            </div>
        </div>
        <div style="position: absolute; bottom: 0; width: 100%; left: 50%; transform: translateX(-50%); text-align: center;">
          <div @click="completeAction" class="later_btn">나중에 할게요</div>
        </div>
    </div>
</template>

<script>
import { POSITION_TYPE } from '@/Constants';

export default {
    name: 'FindPositionHome',
    props: {
        completeAction: {
            type: Function,
            default: () => { }
        }
    },
    methods: {
        findPositionLite() {
            this.$GlobalStore.addModal('FindPositionProMain', { type: POSITION_TYPE.LITE, isSignup: true });
        },
        findPositionPro() {
            this.$GlobalStore.addModal('FindPositionProMain', { type: POSITION_TYPE.PRO, isSignup: true });
        }
    }
}
</script>

<style scoped>
.position_card {
    border-radius: 12px;
    position: relative;
    height: 300px;
    overflow: hidden;
}

.back_img {
    position: absolute;
    width: 100%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
}

.lite {
    background-color: var(--color-main);
}

.pro {
    background-color: #213D51;
}

.badge {
    padding: 4px 8px;
    background-color: #fff;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    align-self: flex-start;
    margin-left: 12px;
    margin-top: 12px;
}

.position_card_content_wrapper {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.position_card_content {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
}

.position_card_content_title {
    text-align: center;
    font-size: 14px;
    font-weight: 900;
    line-height: 20px;
    margin-top: 8px;
    color: #fff;
    white-space: nowrap;
}

.position_card_content_desc {
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    color: #fff;
    margin-top: 16px;
    margin-bottom: 40px;
    text-align: center;
}

.special_color {
    background: conic-gradient(from 180deg at 48.5% 50%, #B8C9D3 -28.12deg, #FBFBFD 26.25deg, #C8D4DA 88.12deg, #FFFFFF 156.58deg, #AEC0CE 191.74deg, #E3E9EE 237.13deg, #FAFBFC 255.19deg, #D6DFE6 310.11deg, #B8C9D3 331.88deg, #FBFBFD 386.25deg);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
    font-weight: 900;
    font-size: 54px;
}

.pro_desc {
    position: absolute;
    bottom: -21px;
    width: 100%;
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
}

.later_btn {
    text-align: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 22px;
    display: inline-block;
    border-bottom: 1px solid #210f03;
}
</style>